/*
 * @Author: LiuMeiYu
 * @Date: 2022-03-03 17:09:34
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-01-29 17:48:28
 * @FilePath: \Nivara\src\main.js
 * @Description: *
 * *
 * Copyright (c) 2022 by yihua, All Rights Reserved.
 */
import {
    createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import installElementPlus from './plugins/element'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// import VueSocketIO from "vue-socket.io"
// new VueSocketIO({
//     debug: true, //debug调试, 生产建议关闭
//     connection: "ws://139.159.231.112:20108",
// })

const app = createApp(App);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
// 时间戳转换想要的时间格式过滤器
app.config.globalProperties.$filters = {
    DateFormatPipe(date, type) {
        if (date) {
            let year, month, day, HH, mm, ss;
            let time = new Date(date * 1000);
            let timeDate;
            year = time.getFullYear(); // 年
            month = time.getMonth() + 1; // 月
            day = time.getDate(); // 日
            HH = time.getHours(); // 时
            mm = time.getMinutes(); // 分
            ss = time.getSeconds(); // 秒

            month = month < 10 ? '0' + month : month;
            day = day < 10 ? '0' + day : day;
            HH = HH < 10 ? '0' + HH : HH; // 时
            mm = mm < 10 ? '0' + mm : mm; // 分
            ss = ss < 10 ? '0' + ss : ss; // 秒

            switch (type) {
                case 'yyyy':
                    timeDate = String(year);
                    break;
                case 'yyyy-MM':
                    timeDate = year + '-' + month;
                    break;
                case 'yyyy-MM-dd':
                    timeDate = year + '-' + month + '-' + day;
                    break;
                case 'yyyy/MM/dd':
                    timeDate = year + '/' + month + '/' + day;
                    break;
                case 'yyyy-MM-dd HH:mm':
                    timeDate = year + '-' + month + '-' + day + ' ' + HH + ':' + mm;
                    break;
                case 'yyyy-MM-dd HH:mm:ss':
                    timeDate = year + '-' + month + '-' + day + ' ' + HH + ':' + mm + ':' + ss;
                    break;
                case 'HH:mm:ss':
                    timeDate = HH + ':' + mm + ':' + ss;
                    break;
                case 'MM':
                    timeDate = String(month);
                    break;
                default:
                    timeDate = year + '-' + month + '-' + day;
                    break;
            }
            return timeDate;
        } else {
            return '';
        }
    },
    //秒数转化为时分秒
    formatSeconds(value) {
        var secondTime = parseInt(value);// 秒
        var minuteTime = 0;// 分
        var hourTime = 0;// 小时
        if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
            //获取分钟，除以60取整数，得到整数分钟
            minuteTime = parseInt(secondTime / 60);
            //获取秒数，秒数取余，得到整数秒数
            secondTime = parseInt(secondTime % 60);
            //如果分钟大于60，将分钟转换成小时
            if (minuteTime > 60) {
                //获取小时，获取分钟除以60，得到整数小时
                hourTime = parseInt(minuteTime / 60);
                //获取小时后取余的分，获取分钟除以60取余的分
                minuteTime = parseInt(minuteTime % 60);
            }
        }
        var result = ""
        if (secondTime == 0) {
            result = "00";
        }else if (secondTime > 0 && secondTime < 10) {
            result = "0" + parseInt(secondTime);
        } else {
            result = "" + parseInt(secondTime);
        }
        if (minuteTime > 0 && minuteTime < 10) {
            result = "0" + parseInt(minuteTime) + ":" + result;
        } else {
            result = "" + parseInt(minuteTime) + ":" + result;
        }
        if (hourTime > 0 && hourTime < 10) {
            result = "0" + parseInt(hourTime) + ":" + result;
        } else {
            result = "" + parseInt(hourTime) + ":" + result;
        }
        return result;
    },
    cardNumberReplace(value) {
        if (!value) return;
        var reg = /^(\d{1})\d+(\d{4})$/;
        let replaceValue = value.replace(reg, "****$2");
        return replaceValue;
    },
    // 向上取整
    rewardMathCeil(value) {
        if (!value) return 0;
        return Math.ceil(value);
    }
}
installElementPlus(app);
app
    .use(store)
    .use(router)
    .mount('#app');